<template>
  <div
    v-if="
      (this.getResource && this.getResource.length > 0) || getTools.length > 0
    "
  >
    <ProductDrawerNew heading="Resources &amp; Tools">
      <div v-if="showResources">
        <div class="productResources__resourceSectionText">Resources</div>
        <div class="productResources__midWidthDivider" />

        <!-- Cutsheet section -->
        <div class="productResources__resourceTitleText" v-if="showSpecifications" >
          Product Specifications
          <ul>
            <li class="productResources__resourceList">
              <BaseButton                 
                class="productResources__resourceName cutsheetlink"
                v-on:click="displayprogreshwheel();"
              >
                CutSheet
              </BaseButton>
              <a class="productResources__resourceType"> (PDF)             
              </a>
              <a ref="refSpinner" style="display: none"><Spinner style="margin-left: 150px; margin-top: -22px;"/></a>
              
            </li>
          </ul>
          <div class="productResources__widthDivider"></div>
        </div>
        <!-- /Cutsheet section -->

        <div v-if="this.getResource && this.getResource.length > 0">
          <div
            class="productResources__resourceTitleText"
            v-for="name in getResource"
            :key="name.id"
          >
            {{ name.Title }}
            <ul v-for="resource in name.Resources" :key="resource.id">
              <li class="productResources__resourceList">
                <a
                  class="productResources__resourceName"
                  v-if="resource.FileType === 'PDF'"
                  :href="resource.Url"
                  target="_blank"
                  >{{ resource.FileName }}</a
                >
                <a
                  class="productResources__resourceName"
                  v-if="
                    resource.FileType === 'Internal Link' ||
                      resource.FileType === 'External Link'
                  "
                  :href="resource.Url"
                  :target="
                    resource.FileType === 'External Link' ? '_blank' : '_self'
                  "
                  >{{ resource.FileName }}</a
                >
                <a
                  class="productResources__resourceName"
                  v-if="
                    !['Internal Link', 'External Link', 'PDF'].includes(
                      resource.FileType
                    )
                  "
                  :href="resource.Url"
                  download
                  >{{ resource.FileName }}</a
                >
                <a class="productResources__resourceType"
                  >&#32;({{ resource.FileType }})</a
                >
              </li>
            </ul>
            <div class="productResources__widthDivider" />
          </div>
        </div>
      </div>
      <ProductTools />
    </ProductDrawerNew>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import ProductTools from "./ProductTools.vue";
import ProductDrawerNew from "./ProductDrawerNew.vue";
import htmlToPdf from "html-to-pdf-js";
import Spinner from "./common/PDPSpinner.vue";
export default {
  computed: {
    ...mapGetters("product", ["getProductSeries", "getProductTitle"]),
    ...mapGetters("enhancedproduct", [
      "getEnhancedTools",
      "getEnhancedProductSeries",
      "getEnhancedProductTitle"
    ]),
    ...mapGetters("prodspecification", ["getSpecification"]),
    ...mapGetters("resources", ["getResource"]),
    showResources() {
      return this.getResource && this.getResource.length > 0;
    },
    showSpecifications() {
      return this.getSpecification && this.getSpecification.length > 0;
    },    
    getTools() {
      if (this.getProductSeries && this.getProductSeries.Tools)
        return this.getProductSeries.Tools;
      else if (this.getEnhancedProductSeries && this.getEnhancedTools)
        return this.getEnhancedTools;
      else return [];
    }
  },
  methods: {    
  displayprogreshwheel(){
  this.$refs.refSpinner.style.display="block";  
  setTimeout(() => {
      this.generateCutsheetPdf(); // Call the cutsheet after a short delay
    }, 0);
  },
    generateCutsheetPdf() {
      // grab the two areas you want:      
      var createdDate = new Date().toString();
      const descWrapper = document.querySelector(".productPage");
      const showMore = document.querySelector(".drawerShowMore");      
      // build a temporary container
      const container = document.createElement("div");
      if (descWrapper) container.appendChild(descWrapper.cloneNode(true));
      if (showMore) container.appendChild(showMore.cloneNode(true));
      var htmlComp = ""; 
     htmlComp = `<!DOCTYPE html>
<html>
<head>
<style>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  border-styel: hidden;
  border-top: 3px solid #b7d6e1;
  width: 95%;
}
.subtable{
border: 0px;
}
.tdcolumn1 {
font-family: acumin-pro, Helvetica, Arial, sans-serif;
    color: #262626;
    font-size: 20px;
    letter-spacing: .25px;
    text-align: left;
    border-bottom: 1px solid #d8d8d8;
    border: 0px;    
    padding-bottom: 8px;
    font-weight: 700;
    line-height: 39px;
}
.tdcolumn2 {font-family: acumin-pro, Helvetica, Arial, sans-serif;
border: 0px;
    color: #545454;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 30px;
    width: 50%;
    text-align: left;
}
.tdcolumn3{
    text-align: left;
    border: 0px;
    font-family: acumin-pro, Helvetica, Arial, sans-serif;
    color: #545454;
    font-size: 16px;
    letter-spacing: 0;
}
td, th {  
  text-align: left;
  padding: 8px;
  vertical-align: text-top;
}
tr {
border-bottom: 3px solid #b7d6e1;
}
.tr2 {
border-bottom: 1px solid #d8d8d8;
}
tr:nth-child(even) {
  
}
</style>
</head>
<body style="padding-left:5px">
<div style="padding: 18px">
<h2 style="font-size: 32px; line-height: 48px; letter-spacing: -.1px;    color: #262626;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    font-size: 26px;
    font-family: acumin-pro, Helvetica, Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 39px;
    text-align: left;
    border-bottom: 3px solid #b7d6e1;
    padding-bottom: 5px;
    padding-top: 20px;";>Specifications</h2>
<h3 style="display: block;
    color: #545454;
    letter-spacing: .2px;
    line-height: 24px;
    font-family: acumin-pro, Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    margin-bottom: 10px;"> Specifications for ${ this.getProductTitle || this.getEnhancedProductTitle } </h3>
<table class="tableparent">`;
for (var i = 0; i < this.getSpecification.length; i++) { 
             var specDetail = this.getSpecification[i];     
  htmlComp = htmlComp + 
  `<tr>
    <td class="tdcolumn1">${ specDetail.Title }</td>
    <td> 
    <table class="subtable">`;      
      for (var j = 0; j < specDetail.SpecificationsDetails.length; j++) {
          var detail = specDetail.SpecificationsDetails[j];
        htmlComp = htmlComp + 
        `<tr class="tr2"><td style="width:50%;">${detail.AttibuteText}</td>
        <td style="width:50%;">`;
        if( detail.AttibuteValue.length > 1){
        htmlComp = htmlComp + `<ul>`;
          for (var k = 0; k < detail.AttibuteValue.length; k++) {
          htmlComp = htmlComp + `<li>&bull; ${detail.AttibuteValue[k]}</li>`;
          }
        htmlComp = htmlComp + `</ul>`;
        }else{
         htmlComp = htmlComp + `${detail.AttibuteValue[0]}`;
        }
        htmlComp = htmlComp +`</td></tr> `;
        }
      htmlComp = htmlComp + 
    `</table>
    </td>
  </tr>`; 
  }
 htmlComp = htmlComp +  
`</table>
<div style="text-align: right; padding-right:37px"> Created: ${createdDate.substring(3, 15)}</div>
</div>
</body>
</html>`;
    //"hand off to html-to-pdf-js",
    htmlToPdf().from(htmlComp).set({ filename: "Cutsheet.pdf" }).save(); 
    this.$refs.refSpinner.style.display="none";
    }
  },
  components: {
    ProductTools,
    ProductDrawerNew,
    Spinner
  }
};
</script>

<style lang="scss" scoped>
.productResources {
  display: block;
  color: $gray-darker;
  letter-spacing: $letter-spacing-md;
  line-height: 31px;
  font-family: $body;
  font-size: 24px;
  text-align: left;
  margin-top: 19px;
  margin-bottom: 20px;

  @include media-breakpoint-up(md) {
    margin-top: 17px;
    margin-bottom: 24px;
    font-size: 20px;
    letter-spacing: $letter-spacing-sm;
  }

  @include media-breakpoint-up(lg) {
    margin-top: 15px;
    margin-bottom: 42px;
    letter-spacing: $letter-spacing-md;
    font-family: $body;
    font-size: 24px;

    &__smallWidthDivider {
      border-bottom: 2px solid $secondary-300;
      margin-bottom: 44px;
    }
  }

  &__fullWidthDivider {
    display: block;
    height: 1px;
    background: $black-33;
    border-radius: 0px;
    width: 100%; /* vw fallback for ie*/
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    margin-bottom: 20px;
    margin-top: 20px;
    @include media-breakpoint-up(md) {
      margin-bottom: 18px;
    }
    @include media-breakpoint-up(lg) {
      left: 57%;
      margin-left: -57vw;
    }
  }
  &__midWidthDivider {
    display: block;
    height: 3px;
    background: $secondary-300;
    border-radius: 0px;
    width: 100%; /* vw fallback for ie*/
    position: relative;
    margin-bottom: 13px;
    @include media-breakpoint-up(md) {
      margin-bottom: 13px;
    }
  }

  &__widthDivider {
    display: block;
    height: 1px;
    background: $gray-light;
    border-radius: 0px;
    width: 100%; /* vw fallback for ie*/
    position: relative;
    margin-bottom: 13px;
    @include media-breakpoint-up(md) {
      margin-bottom: 13px;
    }
  }

  &__resourceSectionText {
    font-family: $body;
    color: $black-66;
    font-size: 16px;
    letter-spacing: $letter-spacing-xs;
    line-height: 30px;
    text-align: left;
    padding-bottom: 2px;
    margin-top: 20px;
    font-weight: normal;

    @include media-breakpoint-up(md) {
      letter-spacing: $letter-spacing-md;
      padding-bottom: 4px;
    }

    @include media-breakpoint-up(lg) {
      font-size: 20px;
      margin-top: 25px;
      width: 34%;
      line-height: 30px;
    }
  }
  &__resourcesHeader {
    display: block;
    color: $gray-darker;
    letter-spacing: $letter-spacing-sm;
    line-height: 31px;
    font-family: $body;
    font-size: 18px;
    text-align: left;
    margin-bottom: 24px;
    margin-top: 24px;
    @include media-breakpoint-up(md) {
      font-size: 20px;
      margin-bottom: 30px;
      margin-top: 27px;
    }
    @include media-breakpoint-up(lg) {
      font-size: 24px;
      margin-bottom: 38px;
      font-family: $body;
    }
  }
  &__resourceList {
    list-style-type: square;
    font-family: $body;
    color: $primary;
    font-size: 16px;
    margin-left: 30px;
    margin-bottom: 12px;
    padding-bottom: 5px;
    padding-top: 8px;
    padding-left: 5px;
    font-weight: normal;
    @include media-breakpoint-up(md) {
      padding-bottom: 7px;
    }
    @include media-breakpoint-up(lg) {
      line-height: 30px;
      font-size: 20px;
      .productResources__resourceName:hover {
        text-decoration: underline;
        text-decoration-color: $primary;
        text-underline-offset: 5px;
      }
    }
  }

  &__resourceType {
    color: $black-66;
    @include media-breakpoint-up(lg) {
      :hover {
        text-decoration: none;
        text-decoration-color: none;
      }
    }
  }
  &__resourceTitleText {
    display: block;
    color: $black-85;
    letter-spacing: 0.25px;
    line-height: 24px;
    font-family: $heading;
    font-size: 16px;
    text-align: left;
    margin-bottom: 5px;
    font-weight: bold;
    @include media-breakpoint-up(md) {
      margin-bottom: 13px;
      font-size: 20px;
    }
    @include media-breakpoint-up(lg) {
      padding-top: 0px;
      font-size: 26px;
      line-height: 39px;
    }
    ul li::marker {
      font-size: 12px;
    }
  }
}
.cutsheetlink{
cursor: pointer;
}
</style>
